import React from 'react';
import Button from '../../../../component/ui/Button';
import search from '../../../../assets/image/search-status.svg';
export default function SettingHeaderComponent({ title, subtitle = null, buttons, searchComponent = null }) {
	return (
		<div
			className="d-flex justify-content-between align-items-center sticky-top z-3 py-3 px-2 px-xl-3"
			style={{ backgroundColor: '#EDEDF7' }}
		>
			<div>
				<div className="fs-3 fw-bold text-black">{title}</div>
				{subtitle && (
					<div
						className="fs-5 fw-light text-gray"
						style={{ color: '#718096' }}
					>
						{subtitle}
					</div>
				)}
			</div>
			<div className='d-flex gap-4'>
				{searchComponent && <div
					className="d-flex align-items-center border border-gray rounded-3 shadow-sm p-1"
					style={{ backgroundColor: '#FFFF' }}
				>
					<img
						src={search}
						alt="search-icon"
						width="20"
						height="20"
						className="rounded-circle me-2"
					/>
					<input
						type="search"
						value={searchComponent.searchText}
						placeholder="Search"
						style={{ border: '0' }}
						onChange={(e) => searchComponent.setSearchText(e.target.value)}
						className={`flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400`}
					/>
				</div>}
				<div className="d-flex gap-4 align-items-center">
					{buttons
						.filter((button) => button !== false)
						?.map((button, index) => (
							<Button
								key={button?.id || index}
								type="button"
								button={button?.button}
								add={button?.add}
								close={button?.close}
								dataTestId={button.dataTestId || ''}
								loader={button.loader || false}
								className={`${button?.className} mt-0 px-3`}
								onClick={button?.handler}
								disabled={button.disabled || false}
							/>
						))}
				</div>
			</div>
		</div>
	);
}
